import { AppRoot } from "@/lib/core";
import "@/styles/index.less";
import { App } from "./App";
import "./tailwind.css";

AppRoot(<App />, {
  rootHtml: "root",
});
